import CustomerPage from './CustomerPage';

export default CustomerPage;
